import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import axiosClient from "../../../services/api/axiosInstance";
import type { PromptResponse, PromptTemplate } from "../models/Prompt";

export const PROMPT_QUERY_KEY = "prompt";

export const usePrompt = (promptId: string) =>
  useQuery<PromptResponse>({
    queryKey: [PROMPT_QUERY_KEY, promptId],
    queryFn: async ({ signal }) => {
      try {
        const response = await axiosClient.get<
          Omit<PromptTemplate, "isDefault">
        >(`/api/v1/ai-settings/prompt-templates/${promptId}`, { signal });
        return { ...response.data, isDefault: false };
      } catch (error: unknown) {
        if (axios.isAxiosError(error) && error.response?.status === 404) {
          return { isDefault: true } as const;
        }
        throw error;
      }
    },
    retry: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    refetchOnMount: false,
    staleTime: Infinity,
  });
